import React from 'react';
import { connect } from 'react-redux';
import BarChartWrapper from '../../common/bar-chart-wrapper';
import { REDUCER_NAME } from '../../reducer';
import Chart from './BarChart';
import Loading from '../../../../common/loading/Loading';

class ChartComponent extends React.Component {
  render() {
    const { isLoading, title, data, toolTip } = this.props;

    const labelColor = '#ffffff';

    if (data.length === 0 && !isLoading)
      return <div>{`No data available for ${title}`}</div>;

    return (
      <BarChartWrapper title={title} toolTip={toolTip}>
        {isLoading ? (
          <Loading />
        ) : (
          <Chart {...this.props} labelColor={labelColor} />
        )}
      </BarChartWrapper>
    );
  }
}

const mapStateToProps = state => {
  return {
    component: state[REDUCER_NAME].component,
    i18n: state.i18n,
    theme: state.theme,
    // do not remove theme , it set color for chart in {...this.props}
  };
};

export default connect(mapStateToProps)(ChartComponent);
